<template>
  <div>
    <b-sidebar
      id="sidebar-filter"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-filter-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div>
          <div
            class="p-2 d-flex justify-content-between align-items-center"
          >
            <label class="header-text font-weight-bold">กรองข้อมูล</label>
            <label class="pointer" @click="hide"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div>
            <div class="p-2 detail-panel">
              <InputText
                textFloat="หมายเลขศัพท์ (Phone no.)"
                v-model="filter.telephone"
                class="mb-2"
                placeholder="Phone no."
                type="text"
              />
              <InputText
                textFloat="ชื่อสมาชิก (Member Name)"
                v-model="filter.name"
                class="mb-2"
                placeholder="Name"
                type="text"
              />
              <!-- <div class="pb-2">
                <div class="font-weight-bold">
                  ปี (Year)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.year"
                  :options="yearConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div> -->
              <div class="pb-2">
                <div class="font-weight-bold">
                  เดือนเกิด (Birth Month)
                </div>
                <b-dropdown
                  id="dropdown-birthday"
                  ref="dropdownBirthdayMonth"
                  class="dropdown-btn"
                >
                  <template #button-content>
                    <label
                      >เดือนเกิด ({{ filter.birthdayMonth.length }})</label
                    >
                  </template>
                  <b-dropdown-form>
                    <b-form-checkbox
                      v-model="selectMonthAll"
                      @change="selectAll"
                    >
                      ทั้งหมด
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-for="(b, index) in monthConfig"
                      :key="index"
                      v-model="filter.birthdayMonth"
                      :value="b.id"
                    >
                      {{ b.name }}
                    </b-form-checkbox>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
              <!-- <div class="pb-2">
                <div class="font-weight-bold">
                  ลูกค้าใหม่รายเดือน (New Customer / Month)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.newRegisterMonth"
                  :options="newCustomerMonthConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div class="pb-2">
                <div class="font-weight-bold">
                  ยอดสะสมสาขาสุทธิ (Current Branch Spending)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.currentSpending"
                  :options="spendingConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div class="pb-2">
                <div class="font-weight-bold">
                  ยอดสะสมต่างสาขาสุทธิ (Other Branch Spending)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.otherSpending"
                  :options="spendingConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div class="pb-2">
                <div class="font-weight-bold">
                  กลับมาซื้อภายใน X เดือน
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.returnMonth"
                  :options="monthNoConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div class="pb-2">
                <div class="font-weight-bold">
                  จำนวนครั้งที่ซื้อ (Frequency)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.frequency"
                  :options="frequencyConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div class="pb-2">
                <div class="font-weight-bold">
                  เพศ (Sex)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.gender"
                  :options="genderConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div>
              <div>
                <div class="font-weight-bold">
                  เรียงลำดับ (Sort by)
                </div>
                <b-form-select
                  class="input-container"
                  v-model="filter.sortBy"
                  :options="sortbyConfig"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </div> -->
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="p-2 text-center">
          <div
            class="w-100 d-flex justify-content-between align-items-center"
          >
            <p @click="clearFilter"><u>ล้างตัวกรอง</u></p>
            <b-button
              class="radius-btn w-50"
              @click="submitForm"
              ><span>ค้นหา</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideFilter",
  components: { InputText },
  props: {
    filter: {
      type: Object,
      isRequired: true,
    },
    yearConfig: {
      type: Array,
      isRequired: true,
    },
    monthConfig: {
      type: Array,
      isRequired: true,
    },
    newCustomerMonthConfig: {
      type: Array,
      isRequired: true,
    },
    monthNoConfig: {
      type: Array,
      isRequired: true,
    },
    spendingConfig: {
      type: Array,
      isRequired: true,
    },
    frequencyConfig: {
      type: Array,
      isRequired: true,
    },
    genderConfig: {
      type: Array,
      isRequired: true,
    },
    sortbyConfig: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      selectMonthAll: true,
    };
  },
  watch: {
    "filter.birthdayMonth": {
      async handler(val) {
        if (this.filter.birthdayMonth.length == 12) {
          this.selectMonthAll = true;
        } else {
          this.selectMonthAll = false;
        }
      },
    },
  },
  async created() {},
  methods: {
    show() {
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    selectAll(value) {
      if (value) {
        this.filter.birthdayMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      } else {
        this.filter.birthdayMonth = [];
      }
    },
    async clearFilter() {
      this.filter.telephone = "";
      this.filter.name = "";
      this.filter.year = "0";
      this.filter.birthdayMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.filter.newRegisterMonth = "0";
      this.filter.currentSpending = "0";
      this.filter.otherSpending = "0";
      this.filter.returnMonth = "0";
      this.filter.frequency = "0";
      this.filter.gender = "0";
      this.filter.sortBy = "1";
      this.filter.page = 1;
      this.filter.perPage = 8;
      this.$emit("onSubmitFilter");
    },
    async submitForm() {
      await this.$emit("onSubmitFilter");
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-btn {
  width: 100%;
}
::v-deep .input-container,
::v-deep .dropdown-btn button {
  display: flex;
  height: 100%;
  padding: 0.5rem;
  background-color: white !important;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
</style>
